import { apiInstance } from "shared/api";
import {
  BatchSignCounts,
  BatchSignType,
  CreateBatchSignResponse,
} from "./types";

export const getBatchSignCounts = (): Promise<BatchSignCounts> =>
  apiInstance.get("/v1/batch-sign").then((response) => response.data);

/**
 * Собирает пакет до 50 документов типа и отдаёт ссылку eGov Mobile.
 * Каждый вызов создаёт новый пакет — прежние ссылки перестают работать.
 */
export const createBatchSign = (
  type: BatchSignType,
): Promise<CreateBatchSignResponse> =>
  apiInstance.post(`/v1/batch-sign/${type}`).then((response) => response.data);
